import React, {PropTypes} from 'react';
import IconUpload from '../../Icons/IconUpload';
import style from './UploadFile.scss';
let id = 0;

export class UploadFile extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    accept: PropTypes.string,
    multiple: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    accept: '*/*',
    multiple: false
  };

  componentWillMount() {
    this.id = 'UploadFile' + id++;
  }

  render() {
    const {
      accept,
      className,
      label,
      multiple,
      onChange
    } = this.props;

    return (
      <div className={[style.root, className].join(' ')}>
        <label className={style.label} htmlFor={this.id}>
            <IconUpload color="white" style={{width: 24, height: 24}}/>
          <div className={style.text}>{label}</div>
        </label>
      <input id={this.id}
             type='file'
             accept={accept}
             ref='fileInput'
             multiple={multiple}
             onClick={(e) => {
               e.target.value = null;
             }}
             onChange={(e) => {
               if (e.target.files[0]) {
                 onChange(e.target.files);
               }
             }}/>
    </div>
    );
  }
}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/form/UploadFile/UploadFile.js